// DEBUG
export const DETAILED_CONSOLE_LOGGING = true;

export const NO_SPEAK_TIMEOUT_MS = 10000;
export const NO_TYPE_TIMEOUT_MS = 10000;
export const NO_SUBMIT_TIMEOUT_MS = 60000;
export const NO_TEXT_SUBMIT_TIMEOUT_MS = 600000;
export const MAX_WAIT_FOR_SCORED_RESPONSE_MS = 6000;
export const NO_SUBMIT_TIMER_UPDATE_INTERVAL = 100;
export const SHOW_LOADING_OVERLAY_TIMEOUT_MS = 3375;
export const PAUSE_BETWEEN_FTUE_STEPS = 1000;

export const STATES = {
  INITIALIZING: "INITIALIZING",
  TEST: "TEST",
  FTUE: "FTUE",
  BEGIN_CURRENT_INTERACTION: "BEGIN_CURRENT_INTERACTION",
  TUTOR_SPEAK_PROMPT: "TUTOR_SPEAK_PROMPT",
  LISTEN_USER_INPUT: "LISTEN_USER_INPUT",
  HANDLE_NO_INPUT: "HANDLE_NO_INPUT",
  HANDLE_DONE_CLICKED: "HANDLE_DONE_CLICKED",
  HANDLE_REPEAT_CLICKED: "HANDLE_REPEAT_CLICKED",
  HANDLE_EXCERPTS_CLICKED: "HANDLE_EXCERPTS_CLICKED",
  HANDLE_HINT_CLICKED: "HANDLE_HINT_CLICKED",
  TUTOR_SPEAK_RESPONSE: "TUTOR_SPEAK_RESPONSE",
  CLEANUP: "CLEANUP",
};

export const POINTER_IDS = {
  PROMPT: "PROMPT",
  TIMER: "TIMER",
  YOUR_TURN: "YOUR_TURN",
  REPEAT_BUTTON: "REPEAT_BUTTON",
  HINT_BUTTON: "HINT_BUTTON",
  EXCERPTS_BUTTON: "EXCERPTS_BUTTON",
  MICROPHONE: "MICROPHONE",
  TEXT_BOX: "TEXT_BOX",
  SUBMIT_BUTTOM: "SUBMIT_BUTTOM",
}